export const STORAGE_KEYS = {
  TOKEN: 'cms_admin_token',
  USER: 'cms_admin_user',
};
